
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/arrange_table",
      function () {
        return require("private-next-pages/manual/arrange_table.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/arrange_table"])
      });
    }
  